import { Token } from "@stripe/stripe-js";

import { xget } from "../Fetchv2.js";
import { MGSchema, tests_complete } from "../schemas/mg.schema.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class SubscriptionsAPI {
	async getSubscriptionByPageId(business_id: string, token: string) {
		return xget<{
			subscriptions: PGSchema.subscriptions[];
			payment_methods: Token[];
			default_payment_method?: string;
			sub_used_count: { sub_id: number; kind: number; count: number }[];
		}>(`/pages/${business_id}/subscription`, { token: token });
	}

	async getAllSubUsedDetails(
		business_id: string,
		params: { take?: number; skip?: number; sub_id: PGSchema.sub_used_details["sub_id"]; kind: PGSchema.sub_used_details["kind"]; uid?: PGSchema.sub_used_details["uid"] },
		token?: string
	) {
		let bodyString = JSON.stringify(params);
		return xget<{
			details: {
				uid: PGSchema.sub_used_details["uid"];
				count?: number;
				created_at?: PGSchema.sub_used_details["created_at"];
				template_id?: PGSchema.sub_used_details["template_id"];
				used_id?: PGSchema.sub_used_details["used_id"];
			}[];
			tests_template: Pick<MGSchema.tests, "title" | "tid" | "descrip">[];
			tests_complete: Pick<tests_complete, "_id" | "ts" | "finish_ts" | "start_ts" | "uid" | "tid">[];
		}>(`/pages/${business_id}/subscription/${params.sub_id}`, { params: btoa(bodyString), token: token });
	}
}
